import React, { useState } from "react";
import { Card, Button, Modal } from "react-bootstrap";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse } from "date-fns";
import { enUS } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const locales = {
  "en-US": enUS,
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => 0,
  getDay: (date) => new Date(date).getDay(),
  locales,
});

function CalendrierCampagneR() {
  const [events, setEvents] = useState([
    {
      id: 1,
      title: "Campagne1",
      start: new Date(2023, 3, 1),
      end: new Date(2023, 3, 1),
    },
    {
      id: 2,
      title: "campagne2",
      start: new Date(2023, 2, 1),
      end: new Date(2023, 2, 1),
    },
  ]);
  const [newEvent, setNewEvent] = useState({
    title: "",
    start: "",
    end: "",
    color: "",
  });
  const [allEvents, setAllEvents] = useState(events);

  function handleAddEvent() {
    const eventDate = new Date(newEvent.start);
    const existingEvent = allEvents.find(
      (event) => new Date(event.start).getTime() === eventDate.getTime()
    );
    if (existingEvent) {
      alert("An event already exists for this date.");
    } else {
      setAllEvents([...allEvents, newEvent]);
    }
    setShow(false);
    setNewEvent("");
  }

  //Modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShowAddForm = () => {
    setShow(true);
  };

  //editform
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [start, setStart] = useState("");

  const handleEventSelect = (event) => {
    setSelectedEvent(event);
    setTitle(event.title);
    setStart(event.start);
    setShowModal(true);
  };

  function handleSave() {
    const updatedEvent = { ...selectedEvent, title: title, start: start };
    const updatedEvents = allEvents.map((event) =>
      event === selectedEvent ? updatedEvent : event
    );
    setAllEvents(updatedEvents);
    setShowModal(false);
  }

  function handleCancel() {
    setShowModal(false);
  }
  function handleUpdateColor(event) {
    const updatedEvents = allEvents.map((e) =>
      e.id === event.id ? { ...e, color: "green" } : e
    );
    setAllEvents(updatedEvents);
  }

  return (
    <div className="row mt-2">
      <div className="col-md-12">
        <div className="card-deck ">
          <Card className="Campagne-card-filter">
            <Card.Body className="d-flex flex-column">
              <Button
                onClick={() => handleShowAddForm()}
                className="ml-auto mb-3"
                variant="success"
                style={{ width: "150px" }}
              >
                Ajouter
              </Button>
              <div>
                <Calendar
                  localizer={localizer}
                  events={allEvents}
                  startAccessor="start"
                  style={{ height: 500 }}
                  onSelectEvent={handleEventSelect}
                  eventPropGetter={(event, start, end, isSelected) => {
                    return {
                      style: {
                        backgroundColor: event.color,
                        opacity: 0.8,
                        display: "block",
                        cursor: "pointer",
                      },
                      onClick: () => {
                        if (event.color === "blue") {
                          handleUpdateColor({ ...event, color: "green" });
                        }
                      },
                    };
                  }}
                />
              </div>
            </Card.Body>
          </Card>
          {/* AddEventModal */}
          <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <div
              className="card card-dark"
              style={{ boxShadow: "none", marginBottom: 0 }}
            >
              <div className="card-header">
                <h3 className="card-title">Ajouter Campagne Reseaux sociaux</h3>
                <button className="close">
                  <FontAwesomeIcon
                    icon={faTimes}
                    closeButton
                    onClick={handleClose}
                    style={{ color: "white" }}
                  />
                </button>
              </div>
              <form>
                <div className="card-body">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Nom"
                      value={newEvent.title}
                      onChange={(e) =>
                        setNewEvent({ ...newEvent, title: e.target.value })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Objectif</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Objectif"
                    />
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">
                          Canal de diffusion
                        </label>
                        <select className="custom-select">
                          <option>--</option>
                          <option>Facebook</option>
                          <option>Linkedin</option>
                          <option>Intagram</option>
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">Type</label>
                        <select className="custom-select">
                          <option>--</option>
                          <option>Story</option>
                          <option>Publication</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Contenu</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Contenu ..."
                    ></textarea>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">Cible</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Cible"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">Budget</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Budget"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Date</label>
                        <div className="input-group">
                          <DatePicker
                            className="form-control"
                            id="exampleInputEmail1"
                            placeholder="Date"
                            selected={newEvent.start}
                            onChange={(start) =>
                              setNewEvent({ ...newEvent, start, end: start })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="exampleInputFile">Pieces joints</label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="exampleInputFile"
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="exampleInputFile"
                            >
                              Choose file
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Annuler
              </Button>
              <Button variant="dark" onClick={handleAddEvent}>
                Ajouter
              </Button>
            </Modal.Footer>
          </Modal>
          {/* /.AddEventModal */}
          {/* EditEventModal */}
          <Modal
            show={showModal}
            onHide={handleCancel}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <div
              className="card card-dark"
              style={{ boxShadow: "none", marginBottom: 0 }}
            >
              <div className="card-header">
                <h3 className="card-title">
                  Modifier Campagne Reseaux Sociaux
                </h3>
                <button className="close">
                  <FontAwesomeIcon
                    icon={faTimes}
                    closeButton
                    onClick={handleCancel}
                    style={{ color: "white" }}
                  />
                </button>
              </div>
              <form>
                <div className="card-body">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Nom"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Objectif</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Objectif"
                    />
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">
                          Canal de diffusion
                        </label>
                        <select className="custom-select">
                          <option>--</option>
                          <option>Facebook</option>
                          <option>Linkedin</option>
                          <option>Intagram</option>
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">Type</label>
                        <select className="custom-select">
                          <option>--</option>
                          <option>Story</option>
                          <option>Publication</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Contenu</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Contenu ..."
                    ></textarea>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">Cible</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Cible"
                        />
                      </div>
                      <div className="col">
                        <label htmlFor="exampleInputEmail1">Budget</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Budget"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Date</label>
                        <div className="input-group">
                          <DatePicker
                            className="form-control"
                            id="exampleInputEmail1"
                            placeholder="Date"
                            selected={start}
                            onChange={(date) => setStart(date)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="exampleInputFile">Pieces joints</label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="exampleInputFile"
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="exampleInputFile"
                            >
                              Choose file
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            {/* /.EditEventModal */}

            {/* condition sur les button Ajouter + annuler */}
            <div className="card-footer">
              <div className="row">
                <div className="col">
                  <Button
                    className="btn btn-secondary mr-2"
                    style={{ width: "150px" }}
                    onClick={handleCancel}
                  >
                    Annuler
                  </Button>
                  <Button className="btn btn-danger" style={{ width: "150px" }}>
                    Supprimer
                  </Button>
                </div>
                {/* condition sur les button Ajouter + annuler */}
                <div className="col text-right">
                  <Button
                    className="btn btn-secondary mr-2"
                    style={{ width: "150px" }}
                    onClick={() => {
                      if (selectedEvent) {
                        handleUpdateColor({ ...selectedEvent, color: "green" });
                      }
                    }}
                  >
                    Approuvé
                  </Button>
                  <Button
                    className="btn btn-dark"
                    style={{ width: "150px" }}
                    onClick={handleSave}
                  >
                    Modifier
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default CalendrierCampagneR;
